import { cn } from "@omni/utils/styles";

import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { getHomeDeliveryKey } from "@/utils/deliveryPromise";

type Props = {
    className?: string;
};

export const DeliveryPromise = ({ className }: Props) => {
    const { t } = useGranite();

    const { option } = useDeliveryItemContext();

    return (
        <p className={cn("tw:text-sm tw:font-light tw:m-0", className)}>
            {t(
                getHomeDeliveryKey("pdp") || "",
                option.deliveryTime,
                t(
                    `product.deliveryPromise.timeUnits.${option.deliveryTimeUnit}`
                ),
                option.realTimeStock
            )}
        </p>
    );
};
